import { useMutation, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { governanceApi } from 'src/Services/API';
import { UpdateGovernanceDto } from 'src/types/governance.types';

export const useUpdateGovernance = () => {
  const queryClient = useQueryClient();
  const assetId = useCurrentAssetId();

  return useMutation(
    (data: UpdateGovernanceDto) => governanceApi.updateAssetGovernance(assetId!, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['fetch-asset-details', assetId]);
      },
    }
  );
};
